'use strict';

namespace Core {

    class ScrollToTopWhen {

        constructor(
            private $scope: ng.IScope,
            private $timeout: any,
            private broker: any)
        {
        }

        init (element : ng.IAugmentedJQuery, eventName : string) {
            this.broker.subscribe('ScrollToTopWhen', eventName, e => {
                this.$timeout(function() {
                    angular.element(element)[0].scrollTop = 0;
                }, 100);
            });

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('ScrollToTopWhen');
            });
        }

    }

    angular
        .module('core')
        .directive('scrollToTopWhen', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'A',
                controller: ScrollToTopWhen,
                controllerAs: 'sttw',
                link: function (scope : ng.IScope, el : ng.IAugmentedJQuery, attr, controller : ScrollToTopWhen) {
                    controller.init(el, attr['scrollToTopWhen']);
                }
            };

        });

}
